import { TableConfig } from "../../../../common/tables/config/TableConfig";
import { PLPRTableRow } from "../../../../../../common/tables/product-listing/payout-rule-mapping/PLPRTableRow";
import { SortOrder } from "../../../../../../common/query-filters";
import { CellType } from "../../../../common/tables/config/CellType";

/**
 * Read-only version of DefaultPLPRTableConfig for the CPM detail side sheet.
 * All editable fields are converted to readOnlyText/readOnlyDate, and the CPM
 * column is hidden (since the user is already viewing records for a specific CPM).
 */
export const DefaultPLPRSideSheetTableConfig: TableConfig<PLPRTableRow> = {
    columns: [
        {
            columnName: "payoutRuleId",
            displayName: "Payout Rule ID",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: true,
            width: "220px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "payoutRuleName",
            displayName: "Name",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: true,
            width: "200px",
            sortable: true,
            filterable: false,
        },
        {
            columnName: "startDate",
            displayName: "Start Date",
            cellType: CellType.readOnlyDate,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "210px",
            sortable: true,
            filterable: false,
        },
        {
            columnName: "createdAt",
            displayName: "Created At",
            cellType: CellType.readOnlyDate,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "210px",
            sortable: true,
            filterable: false,
        },
        {
            columnName: "updatedAt",
            displayName: "Updated At",
            cellType: CellType.readOnlyDate,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "210px",
            sortable: true,
            filterable: false,
        },
        {
            columnName: "payoutRuleType",
            displayName: "Type",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "120px",
            sortable: true,
            filterable: false,
        },
        {
            columnName: "startThreshold",
            displayName: "Start Threshold",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "150px",
            sortable: true,
            filterable: false,
        },
        {
            columnName: "vendorProfitSplitPercent",
            displayName: "Vendor Profit %",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "140px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "retailPricePercentApplicable",
            displayName: "Retail Price %",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "120px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "unitCostPercentApplicable",
            displayName: "Unit Cost %",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "120px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "juniperServiceFeePercentApplicable",
            displayName: "Service Fee %",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "120px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "fulfillmentFeePercentApplicable",
            displayName: "Fulfillment Fee %",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "140px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "processingFeePercentApplicable",
            displayName: "Processing Fee %",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "140px",
            sortable: false,
            filterable: false,
        },
        {
            columnName: "shippingSubsidyPercentApplicable",
            displayName: "Shipping Subsidy %",
            cellType: CellType.readOnlyText,
            hidden: false,
            filtered: false,
            sticky: false,
            width: "160px",
            sortable: false,
            filterable: false,
        },
    ],
    filters: {
        expressions: [],
        sortOrder: SortOrder.DESCENDING,
        sortColumn: "startDate",
        pageSize: 50,
    },
};
